import mixpanelCl from '@src/telemetry/integrations/mixpanel'
import { deleteCookie } from './index'
import AuthUtil, { GATSBY_USER_STORAGE_KEY } from '@src/quince-site-common/src/utils/authUtil'
import { getStorage } from '@src/utils/enhancedStorage'

const isBrowser = typeof window !== `undefined`

export const setUser = user => {
  const { tokens, isFederated, ...userInfo } = user ?? {}
  getStorage().setItem(GATSBY_USER_STORAGE_KEY, JSON.stringify(userInfo), { isGlobal: true })
}

export const logout = callback => {
  if (!isBrowser) return
  setUser({})
  deleteCookie('jwt_token_valid_checkout')
  mixpanelCl.reset()
  callback?.()
}

export const isLoggedIn = () => {
  return AuthUtil.isLoggedIn()
}

export const getCurrentUser = () => AuthUtil.getUser()

export const getUserDisplayName = (firstName, lastName) => {
  if (!firstName) {
    return ''
  }

  if (lastName && firstName?.toLowerCase() !== lastName?.toLowerCase()) {
    return `${firstName} ${lastName}`
  }

  return firstName
}
